import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LangContext } from "@/lib/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Included from "@/components/Included";
import Fleet from "@/components/Fleet";
import Destinations from "@/components/Destinations";
import Tours from "@/components/Tours";
import Reviews from "@/components/Reviews";
import Routes from "@/components/Routes";
import BookingForm from "@/components/BookingForm";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FallingLeaves from "@/components/FallingLeaves";
import ScrollTop from "@/components/ScrollTop";

function App() {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <div className="App" data-testid="app-root">
        <FallingLeaves />
        <ScrollTop />
        <div className="grain-overlay" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Included />
          <Fleet />
          <Destinations />
          <Tours />
          <Reviews />
          <Routes />
          <BookingForm />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </LangContext.Provider>
  );
}

export default App;
